export const BASIC_INFO = {
  TYPE: 'type',
  CAMPAIGN_NAME: 'campaignName',
  CAMPAIGN_DESCRIPTION: 'campaignDescription',
};

export const SOURCE_INFO = {
  AUTOCOMPLETE: 'autocomplete',
};
